import { useState, useEffect } from 'react';

const useMediaQuery = (width: number) => {
    const [targetReached, setTargetReached] = useState(false);

    const handleChange = (e: MediaQueryListEvent) => {
        if (e.matches) {
            setTargetReached(true);
        } else {
            setTargetReached(false);
        }
    };

    useEffect(() => {
        const media = window.matchMedia(`(max-width: ${width}px)`);

        media.addEventListener('change', handleChange);

        // Check on mount (callback is not called until a change occurs)
        if (media.matches) {
            setTargetReached(true);
        }

        return () => media.removeEventListener('change', handleChange);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return targetReached;
};

export default useMediaQuery;
